// extracted by mini-css-extract-plugin
module.exports = {"table":"EmployeesTable_table__fJ4Wb"};